import useThemeProps from "../styles/useThemeProps.es.js";
function createUseThemeProps(name) {
  return useThemeProps;
}
export {
  createUseThemeProps
};
//# sourceMappingURL=index.es.js.map
